/* eslint react/no-danger : 0 */
import React from 'react'
import PropTypes from 'prop-types'
import Headline from './Headline/Headline'
import LegalStatement from './LegalStatement'

function Stats({ data }) {
  const { style, topHeadline, statRows, legalStatement } = data
  return (
    <section className="stats">
      <div className="container__inner">
        {topHeadline && <Headline data={topHeadline} />}
        <div className={`stats__${style ? style.toLowerCase() : 'stripes'}`}>
          {style === 'Boxes' ? <div className="stats__gray-background" /> : null}
          {statRows?.map(row => {
            let content = row.numbers?.toUpperCase()
            const { numbersTextSize } = row
            if (content) {
              content = content?.replace(/\*/g, '<sup class="stats__asterisk">*</sup>')
              content = content?.replace(/\^/g, '<sup class="stats__asterisk">^</sup>')
            }
            const background = row.backgroundColor?.toLowerCase() || 'primary'
            const topClass = `stats__row stats__background-${background}`
            const text = style === 'Boxes' ? row.text : row.text?.toUpperCase()
            return (
              <div className={topClass} key={`${row.text}_${Date.now()}`}>
                <div className="stats__row-content">
                  <div className="stats__column">
                    {style !== 'Boxes' && (
                      <p className="stats__range">{row.rangingFrom || 'Ranging From'}</p>
                    )}
                    <p
                      className={`stats__text ${numbersTextSize === 'Large' ? 'large' : ''}`}
                      dangerouslySetInnerHTML={{ __html: content }}
                    />
                  </div>
                  <h5 className="stats__heading" dangerouslySetInnerHTML={{ __html: text }} />
                </div>
              </div>
            )
          })}
        </div>
        {legalStatement ? (
          <section className="people-use gray">
            <LegalStatement data={legalStatement} isStats />
          </section>
        ) : (
          style === 'Stripes' && <div className="empty-headline-bottom" />
        )}
      </div>
    </section>
  )
}

Stats.defaultProps = {
  data: null
}

Stats.propTypes = {
  data: PropTypes.object
}

export default Stats
